<template>
  <div class="sri-page-header">
    <div class="search md-layout">
      <div class="search-box">
        <div class="md-layout-item md-size-15 md-small-size-100">
          <validation-field name="student">
            <label>{{ $t("common.grade") }}</label>
            <md-select name="target" v-model="data.grade" id="target">
              <md-option
                :value="grade.name"
                v-for="(grade, gradeIndex) in gradeList"
                :key="gradeIndex"
                >{{ grade.name }}</md-option
              >
            </md-select>
          </validation-field>
        </div>
        <div class="md-layout-item md-size-25 md-small-size-100">
          <validation-field name="class name" type="autocomplete">
            <isis-autocomplete
              v-model="studentData.displayValue"
              :value.sync="studentData.value"
              :options="studentOpts"
              :delayTime="1000"
              :refetchOptions="
                queryObj =>
                  studentData.refetchOptions(studentData.displayValue, queryObj)
              "
              :fields="studentData.fields"
              :label="studentData.label"
              fetchOnOpen
            />
          </validation-field>
        </div>
        <div class="md-layout-item md-size-15 md-small-size-100">
          <md-button @click.prevent="button.action" class="md-info">
            {{ button.title }}
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service_names, service_paths } from "@/constants/Services";
import { getId } from "@/helpers/utils";

export default {
  name: "sri-page-header",
  props: ["button", "data"],
  components: {},
  data() {
    return {
      studentData: {
        label: this.$t("smi_sri.search_by_full_name"),
        value: "",
        displayValue: "",
        fields: {
          text: "full_name_id",
          value: "_id"
        },
        refetchOptions: (selectedValue, queryObj) => {
          return this.getStudentOpts(selectedValue, queryObj);
        }
      },
      studentOpts: [],
      gradeList: []
    };
  },
  mounted() {
    this.getGrades();
  },
  methods: {
    getGrades() {
      this.$axios
        .get(
          `${service_names.school}/grades`,
          { limit: 12 },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          this.gradeList = response.data.data;
        });
    },
    getStudentOpts(value) {
      return this.$axios
        .get(
          service_paths.students + `/filter`,
          {
            grade: this.data.grade,
            limit: 10,
            search_key: value,
            fields: ["full_name", "student_code"]
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data: resData }) => {
          // get memorized selected when modal is opened
          this.studentOpts = resData.data;
          this.studentOpts = this.studentOpts.map(student => ({
            full_name_id: student.full_name.concat(" - ", student.student_code),
            ...student
          }));
        });
    }
  },
  watch: {
    "studentData.value": {
      handler: function() {
        this.$emit("studentValue", this.studentData.value);
      }
    }
  }
};
</script>

<style lang="scss">
.sri-page-header {
  .md-autocomplete {
    label {
      z-index: auto;
    }
  }
  .search-box {
    display: flex;
    flex: 2;
  }
  .import {
    flex: 1;
    text-align: right;
  }
}
</style>
